
























import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: String,
      required: true,
    },
    parent: {
      type: Array,
      default: () => [location.hostname],
    },
    chat: {
      type: Boolean,
      default: false,
    },
  },
})
